import { PayloadAction } from '@reduxjs/toolkit';

import { SavedFilterData, IState } from '../types/state';

const setSavedFilters = (
  state: IState,
  action: PayloadAction<SavedFilterData>,
) => {
  state.savedFilters.data = action.payload;
};

export default setSavedFilters;
